

import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash';
import { list as transactionTypeList } from '../transaction-type/selector';

const NAME = 'transaction';

export const isLoading = state => state[NAME].isLoading

export const list = state => state[NAME].list

export const selectedId = state => state[NAME].selected

export const selected = createSelector(
  list,
  selectedId,
  (_, props) => props && props.id,
  (_list, _selectedId, _id) => _list[_id || _selectedId]
)

export const transactionTypeIds = createSelector(
  selected,
  selectedTransaction => (get(selectedTransaction,'relationships.types.data') || []).map(type => get(type, 'id'))
)

export const selectedTransactionTypes = createSelector(
  transactionTypeIds,
  transactionTypeList,
  (_transactionTypeIds, _transactionTypeList) => {
    return _transactionTypeIds.reduce((accumulator, current) => {
      return {
        ...accumulator,
        [current]: _transactionTypeList[current]
      }
    }, {})
  }
)